export const content = {
  fr: {
    nav: {
      home: 'Accueil',
      about: 'À propos',
      services: 'Services',
      contact: 'Contact'
    },
    hero: {
      title: 'GROUPE GARANT',
      subtitle: 'Votre tranquilité d\'esprit est notre priorité!',
      description: 'Nous sommes une équipe spécialisée de professionnels de l\'industrie automobile et du service à la clientèle, dédiée à offrir des solutions de garanties prolongées sur mesure.',
      cta: 'Découvrir nos services'
    },
    stats: {
      title: 'Nous nous assurons que vos besoins sont satisfaits et dépassés — à chaque fois que vous avez besoin de nous!',
      items: [
        {
          title: 'Service client de la plus haute qualité',
          description: 'Excellence dans chaque interaction'
        },
        {
          title: 'Processus sans tracas',
          description: 'Simple et efficace'
        },
        {
          title: 'Protection automobile ULTIME',
          description: 'Couverture complète et personnalisée'
        }
      ]
    },
    callout: {
      title: 'Renforcez votre stratégie de suivi après-vente avec nos services spécialisés pour concessionnaires',
      cta: 'En savoir plus'
    },
    about: {
      title: 'À propos de nous',
      content: `Groupe Garant est une équipe spécialisée formée de professionnels issus de l'industrie automobile et du domaine des relations clients. Notre équipe réunit des experts en financement et assurances (F&A), des gestionnaires de concessions automobiles, ainsi que des spécialistes expérimentés du service à la clientèle dans les secteurs du tourisme et de l'hôtellerie — des milieux où la satisfaction client est au cœur de chaque interaction.

Grâce à cette expertise diversifiée, nous apportons une approche centrée sur le client dans l'univers automobile, en créant un lien fort entre la vente et la fidélisation à long terme. Chaque appel, chaque suivi, est une occasion de bâtir la confiance, d'offrir une valeur ajoutée, et de favoriser la récurrence des affaires.

Voilà l'essence même de Groupe Garant.`
    },
    services: {
      title: 'Ce que nous offrons',
      subtitle: 'Solutions personnalisées pour les concessionnaires',
      description: 'Chez Groupe Garant, nous collaborons avec les concessions automobiles et de véhicules récréatifs afin d\'offrir des services de garanties prolongées sur mesure, pensés pour renforcer la relation client et générer de la valeur à long terme...\nSans aucun coût pour la concession!',
      process_intro: 'Voici comment nous procédons :',
      items: [
        {
          title: 'Relance des clients',
          description: 'Nous contactons les clients figurant sur les listes fournies par la concession, qui n\'ont pas souscrit à une garantie prolongée lors de la livraison de leur véhicule.'
        },
        {
          title: 'Offres de couverture prolongée',
          description: 'Nous rejoignons les clients de 2 à 6 ans après l\'achat de leur véhicule, afin de leur proposer des protections mécaniques étendues et personnalisées.'
        },
        {
          title: 'Plans de financement à 0 % d\'intérêt',
          description: 'Toutes nos garanties sont proposées avec des plans de paiement flexibles, sans intérêt, pour faciliter l\'adhésion et répondre aux besoins des clients.'
        },
        {
          title: 'Fidélisation à la concession',
          description: 'Notre objectif principal est d\'inciter les clients à revenir chez leur concessionnaire, entretenir leur relation d\'affaires et les préparer à leur prochain achat, en favorisant un modèle d\'affaires basé sur la clientèle récurrente.'
        },
        {
          title: 'Aucun frais pour la concession',
          description: 'Le modèle d\'affaires de Groupe Garant est basé sur le partage des revenus générés. Il n\'y a aucun frais de démarrage, aucun abonnement, ni coûts cachés. Seulement un partage simple des ventes réalisées.'
        }
      ],
      conclusion: 'En collaborant avec Groupe Garant, les concessionnaires renforcent leur stratégie de suivi après-vente, augmentent leur rentabilité et placent la satisfaction client au centre de leurs priorités.'
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Prêt à transformer votre service après-vente?',
      cta: 'Nous contacter',
      email: 'Info@groupegarant.com',
      phone: '514-909-8231'
    }
  },
  en: {
    nav: {
      home: 'Home',
      about: 'About',
      services: 'Services',
      contact: 'Contact'
    },
    hero: {
      title: 'GARANT GROUP',
      subtitle: 'Your peace of mind is our priority!',
      description: 'We are a specialized team of automotive industry and customer service professionals, dedicated to providing tailored extended warranty solutions.',
      cta: 'Discover our services'
    },
    stats: {
      title: 'We make sure your needs are met, and exceeded — every time you need us!',
      items: [
        {
          title: 'Highest quality of client services',
          description: 'Excellence in every interaction'
        },
        {
          title: 'Hassle-free process',
          description: 'Simple and efficient'
        },
        {
          title: 'ULTIMATE vehicle warranty protection',
          description: 'Complete and customized coverage'
        }
      ]
    },
    callout: {
      title: 'Strengthen your after-sales follow-up strategy with our specialized services for dealerships',
      cta: 'Learn more'
    },
    about: {
      title: 'About Us',
      content: `Groupe Garant is a specialized team born from the combined expertise of professionals in the automotive industry and the world of client relations. Our team is made up of experienced Finance & Insurance (F&I) specialists, dealership managers, and former customer experience experts from the tourism and hospitality sectors — industries where client satisfaction isn't just important, it's everything.

With this diverse background, we bring a client-first mindset to the automotive space, bridging the gap between sales and long-term customer loyalty. We understand that every interaction with a client is an opportunity to build trust, add value, and drive repeat business for dealerships.

That's the foundation of Groupe Garant.`
    },
    services: {
      title: 'What We Offer',
      subtitle: 'Customized solutions for automotive dealerships',
      description: 'At Groupe Garant, we partner with automotive and recreational vehicle dealerships to offer tailored extended warranty services designed to strengthen customer relationships and drive long-term value...\nWithout any cost to the dealership!',
      process_intro: 'Here\'s how we do it:',
      items: [
        {
          title: 'Client Outreach',
          description: 'We contact customers from dealership-provided listings who did not purchase an extended warranty at the time of vehicle delivery.'
        },
        {
          title: 'Extended Coverage Opportunities',
          description: 'We reach out to clients between 2 to 6 years after their original purchase to offer customized extended mechanical protection plans.'
        },
        {
          title: 'Flexible, 0% Financing',
          description: 'All our coverage options are offered with affordable, interest-free payment plans to maximize accessibility and value for your clients.'
        },
        {
          title: 'Dealer Loyalty Focus',
          description: 'Our main objective is to encourage clients to maintain their relationship with the dealership, preparing them for their next purchase and supporting a strong, repeat-client business model.'
        },
        {
          title: 'No Upfront Cost to Dealerships',
          description: 'Groupe Garant operates on a revenue-sharing model. There are no setup fees, subscriptions, or hidden charges. Just a simple split of the revenue generated through actual sales.'
        }
      ],
      conclusion: 'By partnering with Groupe Garant, dealerships strengthen their after-sales follow-up strategy, increase profitability, and place customer satisfaction at the center of their priorities.'
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Ready to transform your after-sales service?',
      cta: 'Contact us',
      email: 'Info@groupegarant.com',
      phone: '514-909-8231'
    }
  }
}; 
